// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  caravanId: __t.u64().primaryKey().name("caravan_id"),
  fromSid: __t.u64().name("from_sid"),
  toSid: __t.u64().name("to_sid"),
  ownerId: __t.u64().name("owner_id"),
  commodity: __t.string(),
  qty: __t.i32(),
  coins: __t.i64(),
  departAt: __t.timestamp().name("depart_at"),
  arriveAt: __t.timestamp().name("arrive_at"),
  status: __t.string(),
});
